<div class="cb-global-form-controls" [ngClass]="'cb-direction-'+layout()"
    *cbGlobalTemplateDefiner="'cb-form-controls'+((formKey())? '-'+formKey() : '')">
    <ng-content select="cb-button"></ng-content>
</div>